import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  getInsertionPropertyCalculationSumValue,
  getInsertionPropertyCalculationSumErrors,
  selectInsertionDisplayErrors
} from "../../business/models/Insertion/insertionSelectors";

import Controls from "./controls/index";

class InsertionCalculationSumField extends PureComponent {
  render() {
    const { component, ...componentProps } = this.props;
    const Control = Controls.decimal;
    return (
      <Control
        component={Control}
        variant="standard"
        disabled
        {...componentProps}
        onChange={this.handleChange}
      />
    );
  }
}

InsertionCalculationSumField.propTypes = {
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired
};

InsertionCalculationSumField.defaultProps = {
  errors: []
};

const mapStateToProps = (state, ownProps) => {
  return {
    value: getInsertionPropertyCalculationSumValue(state, ownProps),
    errors: getInsertionPropertyCalculationSumErrors(state, ownProps),
    displayErrors: selectInsertionDisplayErrors(state)
  };
};

export default connect(mapStateToProps, null)(InsertionCalculationSumField);
